import { PATTERNS } from '../helpers/compilerHelper';

export const RICH_TEXT_TYPES = {
  SECTION: 'SECTION',
  PARAGRAPH: 'PARAGRAPH',
  IMAGE: 'IMAGE',
  IMAGE_GROUP: 'IMAGE_GROUP',
  SUMMARY: 'SUMMARY',
  LEGAL: 'LEGAL',
  QUOTE: 'QUOTE',
  VIDEO: 'VIDEO',
  REFERENCE_GROUP: 'REFERENCE_GROUP',
  ATTACHMENTS_GROUP: 'ATTACHMENTS_GROUP',
  TERM: 'TERM',
  EXAMPLE: 'EXAMPLE',
};

export const buildChilds = (resourceList, item) => {
  const sortedRelations =
    item.$$relationsTo
      ?.filter((o) => ['IS_PART_OF', 'IS_INCLUDED_IN'].includes(o.$$expanded.relationtype))
      .sort((a, b) => a.$$expanded.readorder - b.$$expanded.readorder) ?? [];

  const items = sortedRelations.reduce((childList, relation) => {
    let foundItem = resourceList.find(
      (res) => res.$$meta.permalink === relation.$$expanded.from.href
    );
    if (foundItem) {
      foundItem = foundItem.$$expanded || foundItem;
      childList.push(foundItem);
    }
    return childList;
  }, []);

  return items;
};

export const getImage = (item, type) => {
  const [image] = item.attachments.filter((o) => o.type === type && !o.resized);
  if (!image) return null;

  return {
    href: encodeURI(image.href),
    description: image.description,
    rightsHolder: image.rightsHolder,
    sizes: item.attachments.filter((o) => o.type === type && o.resized),
  };
};

export const getImageWithSize = (item, type, size) => {
  const image = getImage(item, type);

  if (image?.sizes) {
    let sizedImage = null;
    if (size.w && size.h) {
      [sizedImage] = image.sizes.filter((o) => o.width === size.w && o.height === size.h);
    } else {
      [sizedImage] = image.sizes.filter((o) => o.width === size.w);
    }
    if (image.sizes && sizedImage) {
      return {
        href: encodeURI(sizedImage.href),
        description: image.description,
        rightsHolder: image.rightsHolder,
      };
    }
    return image;
  }

  return null;
};

export const getAttachment = (item, type) => {
  const [attachment] = item.attachments.filter((o) => o.type === type);
  if (!attachment) return null;

  return {
    href: attachment.href,
    description: attachment.description ?? attachment.href,
    rightsHolder: attachment.rightsHolder,
    contentType: attachment.contentType,
  };
};

export const addRequirements = (item) => {
  if (!item.$$relationsTo) return [];

  const requirements = item.$$relationsTo.filter((o) => o.$$expanded.relationtype === 'REQUIRES');
  return requirements.map((o) => o.$$expanded.from.href);
};

export const addReferences = (item) => {
  if (!item.$$relationsFrom) return [];

  const references = item.$$relationsFrom.filter((o) => o.$$expanded.relationtype === 'REFERENCES');
  return references.map((o) => o.$$expanded.to.href);
};

export const buildRichTextTree = (resourceList, root) => {
  if (!root) return {};

  const tree = buildChilds(resourceList, root.$$expanded || root);
  return tree;
};

export const calcExternalLink = (item) => {
  if (item.type === 'REFERENCE') {
    const [extRef] = item.$$relationsFrom.filter(
      (o) => o.$$expanded.relationtype === 'REFERENCES' && o.$$expanded.toExternal
    );
    if (extRef) {
      return JSON.parse(extRef.$$expanded.toExternal).href;
    }
    return null;
  }

  return null;
};

export const calcVideoPlayback = (item) => {
  let playback = null;

  if (item.type === 'VIDEO') {
    const [videoItem] = item.attachments.filter((o) => o.type === 'VIDEO');

    if (videoItem) {
      const url = videoItem.playbackUrl;

      if (url !== undefined && url !== '') {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/;
        const match = url.match(regExp);
        if (match && match[2].length === 11) {
          playback = `https://youtube.com/embed/${match[2]}`;
        }
      }
    }
  }

  return playback;
};

export const isMarkedText = (str) => new RegExp(PATTERNS.MARKED_TEXT).test(str);

export const isTerm = (str) => new RegExp(PATTERNS.TERM).test(str);

export const getMarkedTextMode = (key, modes) => {
  if (!modes) return '';

  let result = '';
  Object.keys(modes)?.forEach((mode) => {
    const hrefs = modes[mode];
    if (hrefs?.includes(key)) result = mode;
  });

  return result;
};

export default buildRichTextTree;
